import { uuidv4 } from '@ubeya/shared/utils/uuid';
import moment from 'moment';

export const filterPositionOptionsByBranchId = ({ positionsOptions = [], mappedPositions = {}, branchId }) => {
  if (!branchId) return positionsOptions;
  return positionsOptions.filter(({ value }) => {
    const branchIds = mappedPositions[value]?.branchIds;
    return !branchIds?.length || branchIds.includes(branchId);
  });
};

// Resolves the wage entry effective at the given date: the most recent entry whose
// effectiveDate is on or before it. Returns null when every entry is later.
export const findEffectiveWage = (wages, currentDate = moment()) => {
  if (!Array.isArray(wages) || wages.length === 0) {
    return null;
  }

  const sorted = [...wages].sort((a, b) => moment(b.effectiveDate).diff(moment(a.effectiveDate)));
  return sorted.find(({ effectiveDate }) => moment(effectiveDate).isSameOrBefore(currentDate)) || null;
};

export const generatePositionWageValues = ({
  wage,
  wages = [],
  externalWage = false,
  externalWageKey,
  currentDate = moment()
}) => {
  const positionWages = Array.isArray(wages) ? [...wages] : [];

  if (positionWages.length > 0) {
    const matchingWage = findEffectiveWage(positionWages, currentDate);

    /* if no matching wage to current time, generate empty wage  */
    return (
      matchingWage || {
        wage: { flatHours: 0, flatWage: 0, hourlyWage: 0, id: uuidv4() },
        [externalWageKey]: { flatHours: 0, flatWage: 0, hourlyWage: 0, id: uuidv4() }
      }
    );
  }

  return { [externalWageKey]: externalWage, wage };
};
